import styled from "styled-components";
import { StyledStepNumber } from "@app/common/components/StepNumber";
import { mediaQuery } from "@app/common/responsive/mediaQuery";

export const StyledRegisterPage = styled.main`
  display: flex;
  flex-direction: column;
  padding: 40px 15px 80px;
  color: var(--heading-color);
  background-color: #f4f5f7;

  .pageHeader {
    margin: 0 0 40px;
    font-size: 28px;
    font-weight: 700;
    text-align: center;

    ${mediaQuery({ from: "MD" })`
      font-size: 40px;
    `};
  }

  .card {
    width: 100%;
    max-width: 780px;
    margin: 0 auto;
    padding: 40px 25px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.08);

    ${mediaQuery({ from: "MD" })`
      padding: 80px;
    `};
  }

  h2 {
    margin: 0 0 15px;
    font-size: 30px;
    font-weight: 700;
  }

  h3 {
    margin: 0 0 8px;
    font-size: 22px;
  }

  .lead {
    max-width: 540px;
    margin: 0;
    color: #5b6b76;
  }

  .step {
    display: flex;
    align-items: flex-start;
    gap: 15px;
    margin-top: 40px;

    p {
      margin: 0;
      color: #5b6b76;
    }
  }

  ${StyledStepNumber} {
    flex: 0 0 auto;
    height: 34px;
    width: 34px;
    font-size: 14px;
    background-color: #eceef1;
  }
`;
